var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar is-flex"},[_c('progress',{class:['progress', _vm.variant ? ("is-" + _vm.variant) : '', _vm.size ? ("is-" + _vm.size) : ''],attrs:{"max":_vm.max},domProps:{"value":_vm.value}}),_vm._v(" "),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.percentage + '%'))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245c6556","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-bulma-progress-component/src/ProgressBar.vue
// module id = 2765
// module chunks = 0